import {RootState} from '@/store'
import {ActionTree} from 'vuex'
import {RequestPayload, ServiceApi} from '@payroll/optimus-common'
import {AuthenticationState} from '@/store/modules/authentication'
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";

export const actions: ActionTree<AuthenticationState, RootState> = {

    authenticateViaSms: ({commit, dispatch, state}: any, {requestBody, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setBaseApi('/auth')
            .setRequestName('authenticate')
            .setRequestBody(requestBody)
            .post(requestorCallback)
    },

    sendForgotPwdMail: ({commit, dispatch, state}: any, {requestBody, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setBaseApi('/auth')
            .setRequestName('sendForgotPasswordMail')
            .setRequestBody(requestBody)
            .post(requestorCallback)
    },

    changeExpiredPassword: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
            .setRequestName('changeExpiredPassword')
            .setRequestBody(requestBody)
            .post(requestorCallback)
    },

    resetPassword: ({commit, dispatch, state}: any, {requestBody, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setBaseApi('/auth')
            .setRequestName('resetPassword')
            .setRequestBody(requestBody)
            .post(requestorCallback)
    },

    authenticateWithPassword: ({commit, dispatch, state}: any, {requestBody, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setBaseApi('/auth')
            .setRequestName('authenticateWithPassword')
            .setRequestBody(requestBody)
            .post(requestorCallback)
    },

    getUserDetails: ({commit, dispatch, state, rootGetters}: any, {requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
            .setRequestName('getUserDetails')
            .get(requestorCallback)
    },

    checkMngCompanyExists: ({commit, dispatch, state}: any, {pathVariable, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setBaseApi('/auth')
            .setRequestName('managingCompanyExists')
            .setPathVariable(pathVariable)
            .get(requestorCallback)
    },

    isAuthorizedForPage: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
            .setRequestName('isAuthorizedForPage')
            .setRequestBody(requestBody)
            .post(requestorCallback)
    },

    getManagingCompanyConfig: ({commit, dispatch, state}: any, {pathVariable, requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setBaseApi('/auth')
            .setRequestName('getManagingCompanyConfig')
            .setPathVariable(pathVariable)
            .get(requestorCallback)
    }
}